import React from "react";
import * as Mui from "@mui/material";
import { withStyles } from "tss-react/mui";
import type { WithStyles } from "type/tss";
import * as Icons from "react-feather";
import { styles } from "../style";
import { User } from "model/user";
import * as env from "shared/env";

interface Props extends WithStyles<typeof styles> {
	open: boolean;
	onCancel: () => void;
	onConfirm: () => void;
	user: User;
}

const Component: React.FC<Props> = ({ open, onCancel, onConfirm, user, classes = {} }) => {
	const showHelpLink = user.reseller.id === 577;

	return (
		<Mui.Dialog open={open} onClose={onCancel} maxWidth="sm" fullWidth>
			<Mui.DialogTitle>
				<Mui.Box display="flex" alignItems="center" justifyContent="space-between">
					<Mui.Box display="flex" alignItems="center" style={{ gap: 8 }}>
						<Mui.SvgIcon color="primary" style={{ fontSize: 20 }}>
							<path d="M19 9l1.25-2.75L23 5l-2.75-1.25L19 1l-1.25 2.75L15 5l2.75 1.25L19 9zm-7.5.5L9 4 6.5 9.5 1 12l5.5 2.5L9 20l2.5-5.5L17 12l-5.5-2.5zM19 15l-1.25 2.75L15 19l2.75 1.25L19 23l1.25-2.75L23 19l-2.75-1.25L19 15z" />
						</Mui.SvgIcon>
						<Mui.Typography variant="h6" style={{ fontWeight: "bold", fontSize: 24 }}>Enable Smart Search</Mui.Typography>
					</Mui.Box>
					<Mui.IconButton size="small" onClick={onCancel}>
						<Icons.X size={24} />
					</Mui.IconButton>
				</Mui.Box>
			</Mui.DialogTitle>
			<Mui.Divider style={{ marginLeft: 24, marginRight: 24 }} />
			<Mui.DialogContent>
				<Mui.Typography variant="body1" paragraph style={{ fontWeight: "bold" }}>
					Smart Search will be applied to all search styles across your website.
				</Mui.Typography>
				<Mui.Typography variant="body1" paragraph>
					Smart Search allows visitors to search using natural language. When enabled, quick search styles will display a simplified search experience—additional filters will be hidden to prevent conflicts with Smart Search queries.
				</Mui.Typography>
				<Mui.Typography variant="body1" paragraph>
					This will change the appearance of your search bar.
				</Mui.Typography>
				{showHelpLink && (
					<Mui.Box mb={2}>
						<Mui.Link
							href="https://kb.ihomefinder.com/s/article/smart-search"
							target="_blank"
							rel="noopener noreferrer"
							style={{ display: "inline-flex", alignItems: "center", gap: 4 }}
						>
							Learn More
							<Icons.ExternalLink size={14} />
						</Mui.Link>
					</Mui.Box>
				)}
				<Mui.Typography variant="body1" className={classes.modalBodyBold}>
					Would you like to use Smart Search?
				</Mui.Typography>
			</Mui.DialogContent>
			<Mui.DialogActions className={classes.dialogActions}>
				<Mui.Button variant="outlined" color={"primary"} onClick={onCancel}>
					Cancel
				</Mui.Button>
				<Mui.Button variant="contained" color={"primary"} onClick={onConfirm}>
					Enable Smart Search
				</Mui.Button>
			</Mui.DialogActions>
		</Mui.Dialog>
	);
};

export const ConfirmationModal = withStyles(Component, styles);
